import React from 'react';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { QuickActionBar } from '../components/home/QuickActionBar';
import { WhyChoose } from '../components/home/WhyChoose';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { PrescriptionCollection } from '../components/home/PrescriptionCollection';
import { AboutSection } from '../components/home/AboutSection';
import { AppointmentSection } from '../components/home/AppointmentSection';
import { MedicalAids } from '../components/home/MedicalAids';
export function Home() {
  return <div className="flex flex-col" data-id="element-787" data-mp="29g4yyomk6uxo">
      <HeroCarousel data-id="element-788" data-mp="29f26wddi2mg6" />
      <QuickActionBar data-id="element-789" data-mp="29ek5z3fw7k1x" />
      <WhyChoose data-id="element-790" data-mp="29ihqnti4cjnx" />
      <ServicesOverview data-id="element-791" data-mp="2dhgs344n5yam" />
      <PrescriptionCollection data-id="element-792" data-mp="2dhytsga2p4px" />
      <AboutSection data-id="element-793" data-mp="2dj1lgqf7zb6w" />
      <AppointmentSection data-id="element-794" data-mp="2dfdt3uligutr" />
      <MedicalAids data-id="element-795" data-mp="3kvtn3jbju002" />
    </div>;
}